import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import {
    IonicPage, Loading,
    ModalController, NavController, ToastController, Content, Events, NavParams, AlertController, LoadingController} from 'ionic-angular';
/* Models */
import { SalesrepModel } from '../../models/user/salesrep.model';

/* Filters & Services */
import { Setups } from '../../services/setup';
import { Subject } from 'rxjs';
import { ENV } from '../../environment/environment'
import { AuthWrapper } from '../../infra/authWrapper';
import { UserService } from '../../services/user.service';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import * as _ from "lodash";
import { UtilService } from '../../services/util.service';
import { Storage } from '@ionic/storage';
import { UserModel } from '../../models/user/user.model';
import { StorageService } from '../../services/storage.service';


@IonicPage()
@Component({
    selector: 'login',
    templateUrl: 'login.html'
})
export class Login implements OnInit {
    @ViewChild(Content) content: Content;
    loading: Loading;
    enableRememberMe: Boolean = false;
    information1: string = "";
    information2: string = "";
    information3: string = "";
    information4: string = "";
    environment: string = "";
    deployment_flag: boolean = false;
    isVN: Boolean = false;
    warningNotification: string = '';
    isDisplayWarningNotification: boolean = false;
    isViewDestroyed: boolean = false;
    last_update: string = "";

    // input
    username: string = "";
    password: string = "";

    // params
    email: string = "";

    constructor(
        public modalCtrl: ModalController
        , public toastCtrl: ToastController
        , public setups: Setups
        , public navCtrl: NavController
        , private userService: UserService
        , private msalService: MsalService
        , private authWrapper: AuthWrapper
        , private util: UtilService
        , private changeDetectorRef: ChangeDetectorRef
        , private events: Events
        , private storage: Storage
        , private navParams: NavParams
        , private alertCtrl: AlertController
        , private loadingCtrl: LoadingController
        , private storageService: StorageService
    ) {
        this.isVN = this.util.isRemoveDKSHLogoForVN();
        events.subscribe('display-warning-notification', (isDisplay: boolean, msg: string) => {
            // To avoid redirect to tabs after SSO complete. Login page already destroyed
            if (!this.isViewDestroyed) {
                this.isDisplayWarningNotification = isDisplay
                this.warningNotification = msg;
                this.changeDetectorRef.detectChanges();
                this.content.resize();
            }
        });
    }

    ngOnInit() {
        this.storage.get('environment').then(
            (value) => {
                this.environment = value;
            }
        );

        this.storage.get('last_update').then(
            (value) => {
                this.last_update = value;
            }
        );
    }

    ionViewWillEnter() {
        this.email = this.navParams.data;
        this.storage.get('notice_message').then(
            (value) => {
                if (!_.isEmpty(value)) {
                    this.events.publish('display-warning-notification', true, value);
                } else {
                    this.events.publish('display-warning-notification', false, '');
                }
            }
        );
    }

    async internalAuthentication() {
        if (this.username.trim() == "" && this.password.trim() == "") {
            this.util.displayAlert(this.alertCtrl, "Username & password required", "Username and password cannot be empty!");
            return;
        } else if (this.username.trim() == "") {
            this.util.displayAlert(this.alertCtrl, "Username required", "Username cannot be empty!");
            return;
        } else if (this.password.trim() == "") {
            this.util.displayAlert(this.alertCtrl, "Password required", "Password cannot be empty!");
            return;
        }

        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Logging in");
        this.userService.authenticateUser(this.username, this.password).subscribe(
            (res: UserModel) => {
                this.storageService.setToken(res.token).then(
                    () => {
                        this.storage.set('AuthenticationType', 'legacy').then(
                            () => {
                                this.navCtrl.setRoot('SessionContextSetupPage', res.user_id);
                            }
                        );
                    }
                );
            }
            , (error) => {
                this.util.displayAlert(this.alertCtrl, "Error", "Unable to log in. Please retry!");
                this.loading.dismiss();
            }
            , () => {
                this.loading.dismiss();
            }
        );
    }

    externalAuthentication() {
        this.storage.remove('token').then(
            () => {
                this.storage.set('AuthenticationType', 'sso').then(
                    () => {
                        this.navCtrl.setRoot('SessionContextSetupPage');
                    }
                );
            }
        );
    }

    showTermAndCondition() {
        let topCaculatedOffset = document.getElementById('eo-header').offsetHeight;
        document.documentElement.style.setProperty('--top-offset', topCaculatedOffset + 'px');
        let bottomCaculatedOffset = document.getElementById('eo-footer').offsetHeight;
        document.documentElement.style.setProperty('--bottom-offset', bottomCaculatedOffset + 'px');

        let screenHeight = (window.innerHeight - bottomCaculatedOffset - topCaculatedOffset) + 'px';
        document.documentElement.style.setProperty('--screen-height', screenHeight );

        let TermAndConditionModal = this.modalCtrl.create('TermAndCondition',{},
            { enableBackdropDismiss: false, cssClass: 'modal-fullscreen' }
        );
        TermAndConditionModal.present();
    }

    resizeModal() {

        let topCaculatedOffset = document.getElementById('eo-header').offsetHeight;
        document.documentElement.style.setProperty('--top-offset', topCaculatedOffset + 'px');
        let bottomCaculatedOffset = document.getElementById('eo-footer').offsetHeight;
        document.documentElement.style.setProperty('--bottom-offset', bottomCaculatedOffset + 'px');

        let screenHeight = (window.innerHeight - bottomCaculatedOffset - topCaculatedOffset) + 'px';
        document.documentElement.style.setProperty('--screen-height', screenHeight );
    }

    ngOnDestroy(): void {
        this.isViewDestroyed = true;
    }
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts